export default {
    arrows: true,
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: '10px',
    responsive: [
        {
        breakpoint: 1080,
        settings: {
            arrows: false,
            centerMode: false,
            infinite: false,
            slidesToShow: 2,
        }
        },
        {
        breakpoint: 600,
        settings: {
            arrows: false,
            centerMode: false,
            infinite: false,
            slidesToShow: 1,
            initialSlide: 0,
        }
        }
    ]
}
